import { createContext } from 'react';
import { Services } from 'src/services';

export const ServicesContext = createContext<Services>(undefined!);
